import { ALLOWED_PURCHASE_STATUS } from "../../../../components/components.constants";
import { isEligibleForPurchase } from "../withOriginalValues/withOriginalValues";

const ELIGIBLE_STATUSES = new Set([ALLOWED_PURCHASE_STATUS.SUGGESTED, ALLOWED_PURCHASE_STATUS.EDITED]);

/**
 * Estratégia: retorna a contagem de produtos elegíveis para compra. 
 *
 * A elegibilidade é dupla:
 * a) purchaseStatus deve ser SUGGESTED ou EDITED
 * b) valor de compra calculado deve ser maior que 0 (via isEligibleForPurchase)
 */
export const countSuppliersWithEligibleProducts = ({ purchaseRecommendation }) => {
  if (!purchaseRecommendation?.length) {
    return 0;
  }

  const eligibleProductIds = new Set(
    purchaseRecommendation
      .filter(item => ELIGIBLE_STATUSES.has(item.purchaseStatus) && isEligibleForPurchase(item))
      .map(item => item.productId)
  );

  if (eligibleProductIds.size === 0) return 0;

  return eligibleProductIds.size;
};